// extracted by mini-css-extract-plugin
module.exports =  {"containerWithAvatar":"MainCardContainer-module_containerWithAvatar_d2d80","rightContainer":"MainCardContainer-module_rightContainer_b4b93"};